<template>
  <div>
    <el-dropdown trigger="click" @command="handleSetLang">
      <div class="language-icon--style">
        <svg-icon class-name="language-icon" icon-class="language" />
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            v-for="item of langOptions"
            :key="item.value"
            :disabled="lang === item.value"
            :command="item.value"
          >
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import useAppStore from "@/store/modules/app";
const appStore = useAppStore();
const lang = computed(() => appStore.lang);
const { proxy } = getCurrentInstance();
const langOptions = ref([
  { label: "简体中文", value: "zh-cn" },
  { label: "English", value: "en" },
]);

function handleSetLang(lang) {
  proxy.$modal.loading("正在修改语言，请稍候...");
  appStore.setLang(lang);
  setTimeout("window.location.reload()", 1000);
}
</script>

<style lang='scss' scoped>
.language-icon--style {
  font-size: 18px;
  line-height: 50px;
  padding-right: 7px;
}
</style>